import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=c9b89f62&"
import script from "./contextmenu.vue?vue&type=script&lang=js&"
export * from "./contextmenu.vue?vue&type=script&lang=js&"
import style0 from "./contextmenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports